import React from 'react';
import ReactECharts from 'echarts-for-react';

const Chart = (props) => {
  const { option, height, width } = props;

  return (
    <ReactECharts option={option} style={{ height: `${height}`, width: `${width}` }} />
  );
};

export default React.memo(Chart);
